import type { CriteriaState } from '@entities/search-session';

/**
 * Полнота запроса в процентах — одна на весь экран.
 *
 * Округление вниз: 99.99 — это «данные собраны, но остался неразрешённый
 * вопрос», и показывать такое состояние как «100 %» рядом с выключенной
 * кнопкой значит противоречить самому себе. 100 — только когда backend
 * разрешил подбор (`ready_for_confirmation`).
 *
 * Число читают и панель критериев, и кнопка шторки «Meine Kriterien · N %»
 * на узком экране. Пока каждая округляла по-своему, при 77.78 панель
 * показывала 77 %, а кнопка рядом — 78 %.
 */
export function readinessPercent(
  criteria: Pick<CriteriaState, 'readiness_score' | 'ready_for_confirmation'>,
): number {
  return criteria.ready_for_confirmation ? 100 : Math.floor(criteria.readiness_score);
}
